export default 'M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4';